import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { FormHandlerService } from 'app/shared/forms/index';
import { ApolloMutationService } from 'app/shared/apollo/index';

@Component({
  selector: 'customer-price-row-project-cost-type',
  templateUrl: 'project-cost-type-row.component.html',
  styleUrls: ['customer-price-row-project-cost-type.scss'],
  providers: [FormHandlerService],
})
export class CustomerPriceProjectCostTypeRowComponent implements OnInit {
  @Input() dataObjectFromParent;
  loading = false;
  hasTyped = false;
  dataModel = 'projectCostType';
  dataModelCapitalized = 'ProjectCostType';
  componentMainForm: FormGroup;
  formFields = {
    model: this.dataModelCapitalized,
  };

  constructor(
    private formHandler: FormHandlerService,
    private mutationService: ApolloMutationService
  ) {}

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.formFields['attributes'] = {
      procent: this.dataObjectFromParent.procent,
    };
    this.componentMainForm = this.formHandler.groupedFormSimple(
      this.formFields
    );
    this.formHandler
      .groupSetLabelsRules(this.formFields, this.componentMainForm)
      .then();
  }

  actionUpdate() {
    if (this.hasTyped) {
      this.costTypeMutation();
    }
  }

  costTypeMutation() {
    const crudType = 'update';
    const dataToMutation = {
      id: Number(this.dataObjectFromParent['id']),
      procent: Number(this.componentMainForm.controls['procent']['value']),
    };

    if (this.formHandler.formValid([this.componentMainForm])) {
      this.loading = true;
      const returnAttributes = ['id', 'procent'];
      const executeMutationSub = this.mutationService
        .constructQueryAndExecuteMutation(
          this.dataModel,
          crudType,
          false,
          dataToMutation,
          returnAttributes
        )
        .subscribe(
          executedData => {
            this.mutationService.displayMutationStatus(executedData);

            this.formHandler.showServerErrorsOnAttributes(executedData, [
              {
                form: this.componentMainForm,
                argument: crudType + this.dataModelCapitalized,
              },
            ]);

            this.loading = false;

            if (executedData.mutationSucceededAllArguments) {
              this.dataObjectFromParent['productsTotalSumWithProcent'] =
                executedData['productsTotalSumWithProcent'];
              this.hasTyped = false;
            }

            executeMutationSub.unsubscribe();
          },
          err => {
            console.log(err);
            this.loading = false;
          }
        );
    }
  }
}
